import { useEffect, useRef, useState } from "react";

const SPECS = ["Brushless Transfer", "PCB Stator", "LogDrive Reduction"];

export const GeneratorConcept = () => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setShown(true);
          obs.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      data-testid="generator-concept"
      className={`mt-20 border border-white/10 bg-[#0a0a0a] transition-all duration-700 ease-out ${
        shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      <div className="px-6 md:px-10 pt-8 flex flex-wrap items-baseline justify-between gap-4">
        <div>
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-[#FF3B30]">
            Concept / Compact Axial Flux Generator
          </div>
          <h3 className="font-display font-black text-3xl md:text-5xl tracking-tighter mt-3">
            One shaft in. Three phases out.
          </h3>
        </div>
        <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-md">
          LogDrive reduction, a brushless rolling ring connector, and a PCB
          axial flux disc stack — a compact generator with fewer parts, no
          brushes to wear, and class-leading power density.
        </p>
      </div>
      <img
        src="/media/compact-generator-axial-flux.png"
        alt="Exploded view of the compact axial flux generator concept: LogDrive input, rolling ring connector, PM rotor discs, PCB stators and finned housing"
        data-testid="generator-concept-image"
        className="w-full mt-8"
        loading="lazy"
      />
      <div className="grid grid-cols-1 sm:grid-cols-3 border-t border-white/10">
        {SPECS.map((s, i) => (
          <div
            key={s}
            data-testid={`generator-spec-${i}`}
            className={`px-6 py-4 font-mono-tech text-[11px] uppercase tracking-widest text-white/80 flex items-center gap-3 ${
              i > 0 ? "sm:border-l border-t sm:border-t-0 border-white/10" : ""
            }`}
          >
            <span className="h-1.5 w-1.5 bg-[#FF3B30] inline-block shrink-0" />
            {s}
          </div>
        ))}
      </div>
    </div>
  );
};
